import { c as _c } from "react/compiler-runtime";
import type { DocumentSide } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useDocumentUploadSideText = () => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldset.documents.details.side"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    const sideLabelMapping = {
      front: t1,
      back: t2,
      selfie: t3
    };
    t4 = side => sideLabelMapping[side];
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default useDocumentUploadSideText;
function _temp($) {
  return $.front;
}
function _temp2($_0) {
  return $_0.back;
}
function _temp3($_1) {
  return $_1.selfie;
}